<template>
  <div :class="classes">
    <v-alert
      border="left"
      colored-border
      type="info"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot name="alert_text" />
      <slot name="edit_alert_text_second" />

    </v-alert>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class extends Vue {
  @Prop({ type: Boolean, default: false })
  is_dark!: boolean;

  get classes() {
    return [
      'info-alert',
      { 'info-alert-dark': this.is_dark },
    ];
  }
}
</script>

<style lang="scss" src="./info-alert.scss" />
